import React from "react";

import { aa } from "./adminAnalyticsUtils";

export default function AdminAnalyticsTabs({ tabs, activeTabId, onTabChange }) {
  return (
    <div
      className="admin-analytics-tabs"
      role="tablist"
      aria-label={aa("tabs_aria", "Admin analytics sections")}
    >
      {tabs.map((tab) => (
        <button
          key={tab.id}
          id={`admin-analytics-tab-${tab.id}`}
          type="button"
          role="tab"
          aria-selected={activeTabId === tab.id}
          aria-controls={`admin-analytics-panel-${tab.id}`}
          className={activeTabId === tab.id ? "is-active" : ""}
          onClick={() => onTabChange(tab.id)}
        >
          {tab.label}
        </button>
      ))}
    </div>
  );
}
